<template>
	<div class="Ordercontent">
		<van-tabs v-model="active" @click="changeTab">
			<van-tab title="已开具发票">
				<div v-if="dataList.length>0">
					<div v-for="(item,i) in dataList" :key="i">
						<a href="javascript:;" class="billBar" @click.stop="gotoInvoicing(item)"
							v-if="item.status==1">
							<van-row>
								<van-col span="24" class="title">{{item.ghdwmc}}<span class="address">{{item.address}}</span></van-col>
								<van-col span="24" class="cont">
									<van-col span="24" class="money"><span class="orange">¥ {{item.money}}</span>
										增值税电子普通发票</van-col>
									<van-col span="16" class="info">订单信息 >></van-col>
									<van-col span="8" class="info">{{item.createTime}}</van-col>
								</van-col>
							</van-row>
						</a>
					</div>
				</div>
				<van-row class="noPayBar" v-if="dataList.length == 0 || num1==0">
					<van-col span="24" class="noPayPC"></van-col>
					<van-col span="24" class="text1 orange">暂无已开具发票信息！</van-col>
				</van-row>
			</van-tab>
			<van-tab title="申请中发票">
				<div v-if="dataList.length>0">
					<div v-for="(item,i) in dataList" :key="i">
						<a href="javascript:;" class="billBar" v-if="item.status==0">
						<!-- <a href="javascript:;" class="billBar"> -->
							<van-row>
								<van-col span="24" class="title">{{item.ghdwmc}}<span class="address">{{item.address}}</span></van-col>
								<van-col span="24" class="cont">
									<van-col span="24" class="money"><span class="orange">¥ {{item.money}}</span>
										增值税电子普通发票</van-col>
									<van-col span="16" class="info">订单信息 >></van-col>
									<van-col span="8" class="info">{{item.createTime}}</van-col>
								</van-col>
							</van-row>
						</a>
					</div>
				</div>
				<van-row class="noPayBar" v-if="dataList.length == 0 || num2==0">
					<van-col span="24" class="noPayPC"></van-col>
					<van-col span="24" class="text1 orange">暂无申请中发票信息！</van-col>
				</van-row>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import {
		Dialog
	} from 'vant';
	import {
		reqInvoiceList
	} from '../../api'
	export default {
		name: "order",
		data() {
			return {
				active: 0,
				orderData: {
					userId: ''
				},
				dataList: [],
				num1: 0, //已开具发票数
				num2: 0 //已申请开票数
			}
		},
		created() {
			this.orderData.userId = this.$cookies.get('userInfo').userId
			this.getOrderList();
		},
		mounted() {},
		methods: {
			gotoInvoicing(item) {
				// console.log(JSON.parse(item))
				this.$router.push({
					path: '/invoicingPreview',
					name: 'invoicingPreview',
					query: item, //标明当前文件,
				})
			},
			/*
			 * 获取订单列表
			 * */
			getOrderList() {
				//获取对应小区
				reqInvoiceList(this.orderData).then(res => {
					this.dataList = []
					if (res.status == '200') {
						var re = JSON.parse(res.data).data.list
						console.log(re)
						for (let i = 0; i < re.length; i++) {
							if (re[i].status == '0') {
								this.num2++
							}
							if (re[i].status == '1') {
								this.num1++
							}
							this.dataList.push(re[i])
						}
						console.log(this.dataList)
					} else {
						Toast.fail({
							message: res.msg,
							className: 'apiLoading'
						});
					}
				})
			},
			changeTab() {
				this.getOrderList()
			},
		}
	}
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .orange
    color #ff6d02
  .Ordercontent
    padding-bottom 80px
    background #f9f9f9
    .van-tabs--line
      .van-tabs__wrap
        height 90px
      .van-tab
        font-size 30px
        line-height 80px
      .van-tab--active
        color #ff6d02
      .van-tabs__content
        padding-top 60px
        .billBar
          display block
          border-top 20px solid #f9f9f9
          .van-row
            padding 0px 54px 40px 50px
            background #fff
          .title
            font-size 32px
            color #333
            padding 42px 0px 12px
            .address
              font-size 28px
              padding-left 15px
              color #888
          .cont
            font-size 28px
            color #888888
            padding-top 10px
            .bill-money
              padding 34px 0px
          .address
            font-size 30px
            color #222222
            line-height 40px
            padding 30px 0px
          .money
            font-size 24px
            color #888888
            span
              font-size 60px
          .info
            padding-top 20px
            margin-top 20px
            font-size 22px
            border-top 1px solid #f9f9f9
    .noPayBar
      margin 10px 0px
      height 626px
      background #ffffff
      text-align center
      .noPayPC
        height 50%
        margin-top 15%
        background url("../Order/images/unfound_5.png") no-repeat center
        background-size 50% auto
      .text1
        font-size 32px
        padding 20px 0px
      .text2
        font-size 24px
        color #aaaaaa
    .van-swipe-cell__right
      padding-top 20px
      .van-button
        width 165px
        height 100%
        font-size 28px
        text-align center
        letter-spacing 6px
    .solidBtn
      width 166px
      height 66px
      font-size 28px
      background #ff6d02
    .hollowBtn
      width 166px
      height 66px
      background transparent!important
      color #ff6d02
      font-size 28px
      border 2px solid #ff6d02
</style>


// WEBPACK FOOTER //
// src/pages/invoicing/invoicingList.vue